import { v4 as uuid } from "uuid";
import { AF1, AF2, AF3, AF4, RUN1, RUN2, RUN3, RUN4, SB1, SB2, SB3, SB4 } from "../../assets/index";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
	{
		_id: uuid(),
		title: "Air Zoom 1",
		company: "Nike",
		price: "8999",
		categoryName: "Running",
		img: RUN1,
		inStock: true,
		rating: "4.2",
	},
	{
		_id: uuid(),
		title: "Air Zoom 2",
		company: "Nike",
		price: "10499",
		categoryName: "Running",
		img: RUN2,
		inStock: true,
		rating: "3.6",
	},
	{
		_id: uuid(),
		title: "Air Zoom 3",
		company: "Nike",
		price: "9999",
		categoryName: "Running",
		img: RUN3,
		inStock: false,
		rating: "4.7",
	},
	{
		_id: uuid(),
		title: "Air Zoom 4",
		company: "Nike",
		price: "6999",
		categoryName: "Running",
		img: RUN4,
		inStock: true,
		rating: "3.7",
	},
	{
		_id: uuid(),
		title: "Air Force 1 '07",
		company: "Nike",
		price: "7899",
		categoryName: "Air Force 1",
		img: AF1,
		inStock: true,
		rating: "2.6",
	},
	{
		_id: uuid(),
		title: "Air Force 1 High",
		company: "Nike",
		price: "8499",
		categoryName: "Air Force 1",
		img: AF2,
		inStock: false,
		rating: "3.2",
	},
	{
		_id: uuid(),
		title: "Air Force 1 Crater",
		company: "Nike",
		price: "9499",
		categoryName: "Air Force 1",
		img: AF3,
		inStock: true,
		rating: "4.6",
	},
	{
		_id: uuid(),
		title: "Air Force 1 Luxe",
		company: "Nike",
		price: "14999",
		categoryName: "Air Force 1",
		img: AF4,
		inStock: true,
		rating: "5",
	},
	{
		_id: uuid(),
		title: "Nike SB 1",
		company: "Nike",
		price: "7899",
		categoryName: "SB",
		img: SB1,
		inStock: true,
		rating: "1.9",
	},
	{
		_id: uuid(),
		title: "Nike SB 2",
		company: "Nike",
		price: "8499",
		categoryName: "SB",
		img: SB2,
		inStock: true,
		rating: "4.1",
	},
	{
		_id: uuid(),
		title: "Nike SB 3",
		company: "Nike",
		price: "9499",
		categoryName: "SB",
		img: SB3,
		inStock: false,
		rating: "3.4",
	},
	{
		_id: uuid(),
		title: "Nike SB 4",
		company: "Nike",
		price: "5999",
		categoryName: "SB",
		img: SB4,
		inStock: false,
		rating: "3.8",
	},
];
